import { applyMiddleware, combineReducers, compose, createStore as createReduxStore } from 'redux';
import { routerReducer as router } from 'react-router-redux';
import { reducer as onionForm } from 'onion-form';

import application from './../browser/application/reducer';
import contact from './../browser/Feature/contact_form/reducer';
import downloads from './../browser/Feature/downloads/reducer';
import faq from './../browser/Feature/components/faq/reducer';
import login from './../browser/Feature/login/reducer';
import newsletter from './../browser/Feature/components/newsletter_form/reducer';
import order from './../browser/Feature/order/reducer';
import organizations from './../browser/Feature/components/team_section/reducer';
import workshops from './../browser/Feature/components/workshops/reducer';

const createStore = (initialState = {}, { middlewares = [] }) => {
  const reducers = {
    application,
    router,
    contact,
    downloads,
    newsletter,
    faq,
    onionForm,
    workshops,
    login,
    order,
    organizations
  };

  const customMiddlewares = applyMiddleware(...middlewares);

  const allMiddlewares = process.env.IS_BROWSER && window.devToolsExtension
    ? compose(customMiddlewares, window.devToolsExtension())
    : customMiddlewares;

  return createReduxStore(
    combineReducers(reducers),
    initialState,
    allMiddlewares
  );
};

export default createStore;



// WEBPACK FOOTER //
// ./src/common/createStore.js